<template>
  <!-- div wrapper needed as workaround for tooltips to work with v-selects  -->
  <v-select
    v-model="selectedLanguage"
    :disabled="disabled"
    :items="allLanguages"
    :rules="rules"
    :loading="isLoading"
    label="Language"
  ></v-select>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  props: {
    languageValue: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    },
    hasAllOption: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    regionFilter: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    allLanguages() {
      let langs = this.$store.state.languages.languages
        .reduce((filtered, lang) => {
          if (
            this.regionFilter == 0 ||
            lang.region.some(r => r.region === this.regionFilter)
          ) {
            if (filtered.indexOf())
              filtered.push({
                text: lang.description,
                value: lang.iso6391
              });
          }
          return filtered;
        }, [])
        .sort(this.compare);
      langs = Array.from(new Set(langs));
      if (this.hasAllOption) {
        langs.unshift({ text: 'All', value: '' });
      }
      return langs;
    },
    selectedLanguage: {
      get: function() {
        return this.languageValue;
      },
      set: function(newValue) {
        this.setSearchLanguage(newValue);
        this.$emit('input', newValue);
      }
    }
  },
  created() {
    this.isLoading = true;
    this.getLanguages()
      .then(() => {
        this.isLoading = false;
      })
      .catch(error => {
        this.isLoading = false;
        this.showSnackbar({ text: error, color: 'error', timeout: 3000 });
      });
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    ...mapMutations('languages', ['setSearchLanguage']),
    ...mapActions('languages', ['getLanguages']),
    compare(a, b) {
      if (a.text > b.text) {
        return 1;
      } else {
        return -1;
      }
    }
  }
};
</script>

<style></style>
